import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroContent } from './IntroContent';
import { KeyHighlights } from './KeyHighlights';
import { GuidelinesLink } from './GuidelinesLink';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function BowlingPinPage() {
  return <PageLayout data-id="element-408">
      <HeaderBanner data-id="element-409" />
      <IntroContent data-id="element-410" />
      <KeyHighlights data-id="element-411" />
      <GuidelinesLink data-id="element-412" />
      <ContactSection data-id="element-413" />
      <QuickLinks data-id="element-414" />
    </PageLayout>;
}